"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchOverlay = exports.SearchBarInput = exports.SearchBarContainer = exports.SearchPageContainer = exports.SearchClearButton = exports.SearchButton = exports.SearchIcon = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _search = _interopRequireDefault(require("@bit/knotchinc.web-react-components.icons.search/search.svg"));

var _knotchincWebReactComponents = require("@bit/knotchinc.web-react-components.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  transition: opacity 400ms ease-in-out;\n  will-change: transform;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  position: fixed;\n  visibility: ", ";\n  transition-delay: 250ms;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  transition: transform 500ms cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition-delay: 250ms;\n  height: 70px;\n  font-size: 14px;\n  line-height: 20px;\n  border: 0;\n  padding: 0;\n  width: 90%;\n  outline: none;\n  color: white;\n  background-color: inherit;\n  font-weight: normal;\n  font-family: Brandon, sans-serif;\n  transform: translate(", ", 0);\n\n  ::placeholder {\n    letter-spacing: 0.02em;\n    color: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  visibility: ", ";\n  background-color: ", ";\n  transition-delay: 250ms;\n  height: 70px;\n  position: relative;\n  width: 100%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  height: ", ";\n  transition: opacity 250ms ease;\n  z-index: 100;\n  opacity: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  font-size: 24px;\n  color: ", ";\n  cursor: pointer;\n  display: ", ";\n  transition-delay: 250ms;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  z-index: 100;\n  cursor: pointer;\n  width: 28px;\n  height: 14px;\n  background-image: url(", ");\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 100;\n  opacity: ", ";\n  transition: opacity 500ms ease;\n  transition-delay: 250ms;\n  display: inline-block;\n  cursor: pointer;\n  background-image: url(", ");\n  background-color: none;\n  width: 5%;\n  margin-left: 20px;\n  height: 14px;\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center center;\n  vertical-align: middle;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SearchIcon = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.open ? '1' : '0';
}, _search["default"]);

exports.SearchIcon = SearchIcon;

var SearchButton = _styledComponents["default"].div(_templateObject2(), (0, _knotchincWebReactComponents.absFull)('30px', '25px', 'auto', 'auto'), _search["default"]);

exports.SearchButton = SearchButton;

var SearchClearButton = _styledComponents["default"].div(_templateObject3(), (0, _knotchincWebReactComponents.absFull)('24px', '28px', 'auto', 'auto'), function (props) {
  return props.theme.colors.palette[6];
}, function (props) {
  return props.display;
});

exports.SearchClearButton = SearchClearButton;

var SearchPageContainer = _styledComponents["default"].div(_templateObject4(), (0, _knotchincWebReactComponents.absFull)(0, 0, 'auto'), function (props) {
  return props.open ? 'auto' : '0';
}, function (props) {
  return props.open ? '1' : '0';
});

exports.SearchPageContainer = SearchPageContainer;

var SearchBarContainer = _styledComponents["default"].div(_templateObject5(), function (props) {
  return props.open ? 'visible' : 'hidden';
}, function (props) {
  return props.theme.colors.palette[3];
});

exports.SearchBarContainer = SearchBarContainer;

var SearchBarInput = _styledComponents["default"].input(_templateObject6(), function (props) {
  return props.open ? '0' : '15px';
}, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.palette[5];
});

exports.SearchBarInput = SearchBarInput;

var SearchOverlay = _styledComponents["default"].div(_templateObject7(), function (props) {
  return props.open ? 'visible' : 'hidden';
});

exports.SearchOverlay = SearchOverlay;

//# sourceMappingURL=styled.js.map